// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum VMSExistingSystem {
  VMS50 = 0,
  VMS100 = 1,
  VMS200 = 2,
  VMS300 = 3,
}
